module.exports = __webpack_public_path__ + "img/img-classify1.38077955.png";